/**
 * Página de disponibilidades: cambiar de salida sin recargar.
 *
 * La tira son enlaces reales, así que sin este script la página funciona
 * igual: cada enlace recarga con su salida. Esto solo evita el viaje.
 */
(function () {
  'use strict';

  var tira = document.querySelector('[data-disp-tira]');
  if (!tira) return;

  var titulo = document.querySelector('[data-disp-titulo]');
  var patron = titulo ? titulo.getAttribute('data-patron') : '';

  function mostrar(slug, fechas, url) {
    var rejillas = document.querySelectorAll('[data-disp-grid]');
    var encontrada = false;

    for (var i = 0; i < rejillas.length; i++) {
      var esta = rejillas[i].getAttribute('data-disp-grid') === slug;
      rejillas[i].hidden = !esta;
      if (esta) encontrada = true;
    }

    // Si no hay rejilla para esa salida, mejor dejar que el enlace recargue
    // que quedarse con la pantalla en blanco.
    if (!encontrada) return false;

    var enlaces = tira.querySelectorAll('[data-salida]');
    for (var j = 0; j < enlaces.length; j++) {
      var activo = enlaces[j].getAttribute('data-salida') === slug;
      enlaces[j].classList.toggle('is-activa', activo);
      if (activo) {
        enlaces[j].setAttribute('aria-current', 'true');
      } else {
        enlaces[j].removeAttribute('aria-current');
      }
    }

    if (titulo && patron) {
      titulo.textContent = patron.replace('%s', fechas);
    }

    history.replaceState(null, '', url);
    return true;
  }

  tira.addEventListener('click', function (e) {
    var enlace = e.target.closest('[data-salida]');
    if (!enlace) return;

    if (mostrar(enlace.getAttribute('data-salida'), enlace.getAttribute('data-fechas'), enlace.href)) {
      e.preventDefault();
    }
  });
})();
